import { datadogRum } from '@datadog/browser-rum'
import { Session } from 'next-auth'
import { useEffect } from 'react'

export const useSetDatadogRumUser = ({ session }: { session: Session | null }) => {
  useEffect(() => {
    if (session?.user?.type === 'fullyAuthenticated' && session.user.metadata?.id) {
      datadogRum.setUser({
        id: session.user.metadata.id,
        email: session.user.email,
        name: `${session.user.metadata.firstName} ${session.user.metadata.lastName}`,
        organisationId: session.user.orgMetadata.organisationId,
        organisationName: session.user.orgMetadata.name,
        role: session.user.metadata.role,
        isQaOrg: session.user.orgMetadata.isQaOrg,
      })
    }
    return () => {
      datadogRum.clearUser()
    }
  }, [
    session?.user.email,
    session?.user.metadata?.firstName,
    session?.user.metadata?.id,
    session?.user.metadata?.lastName,
    session?.user.metadata?.role,
    session?.user.orgMetadata?.name,
    session?.user.orgMetadata?.organisationId,
    session?.user.orgMetadata?.isQaOrg,
    session?.user?.type,
  ])
}
